import { render, staticRenderFns } from "./PurchaseRequestButtonBar.vue?vue&type=template&id=32af2008&"
import script from "./PurchaseRequestButtonBar.vue?vue&type=script&lang=js&"
export * from "./PurchaseRequestButtonBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports